const attendeeStatsTransformer = response => {
  const resp =
    response?.data?.attendeesStats?.length &&
    response?.data?.attendeesStats?.map(item => {
      if (item?.snapshot) {
        return {
          ...item,
          data: item?.snapshot?.data,
        }
      }
      return item
    })
  return { ...response, data: { ...response?.data, attendeesStats: resp } }
}

export default attendeeStatsTransformer
